import { Utils__urlParse } from './utils';

function $uuid() {
  return Math.round(2147483647 * Math.random());
}

function uuid() {
  try {
    // 优先使用 crypto API 来生成 uuid
    const u32a = new window.Uint32Array(1);
    window.crypto.getRandomValues(u32a);

    return u32a[0] & 2147483647; // eslint-disable-line
  } catch (b) {
    return $uuid();
  }
}

function setContext(key, value) { // eslint-disable-line
  const perfix = '__sentry_context__';
  let originValue;

  try {
    originValue = window.localStorage.getItem(perfix + key);
    if (originValue) {
      return originValue;
    }

    window.localStorage.setItem(perfix + key, value);
    return window.localStorage.getItem(perfix + key);
  } catch (e) { } // eslint-disable-line
}

export function getTagsContext() {
  let deviceInfo = {};
  const date = new Date();

  try {
    deviceInfo = JSON.parse(window.miui.getDeviceInfo()) || {};
  } catch (e) { } // eslint-disable-line

  const tags = {
    date: `${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}`,
    hostname: window.location.hostname,
    referrer: window.document.referrer,
    referrerHostname: Utils__urlParse(window.document.referrer, 'hostname'),
    nt: deviceInfo.nt || (window.navigator.connection && window.navigator.connection.effectiveType),
    device_hash: deviceInfo.device_hash || setContext('device_hash', uuid()),
    package_name: deviceInfo.package_name || window.navigator.appName,
    version_name: deviceInfo.version_name || window.navigator.appVersion,
    version_code: deviceInfo.version_code || '',
    version_release: deviceInfo.version_release || '',
    version_incremental: deviceInfo.version_incremental || '',
    model: deviceInfo.model || '',
  };

  return tags;
}

export function getUserContext() {
  const user = {
    user_id: setContext('user_id', uuid()),
  };

  return user;
}
